<template>
<div id="app">
   <keep-alive> 
        <router-view v-if="$route.meta.keepAlive">
            <!-- 这里是会被缓存的视图组件，比如 Home！ -->
        </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- 这里是不被缓存的视图组件，比如 Edit！ -->
</div>
</template>

<script>
import router from "../.././router";
import {
    LOGOUT,
    LOGIN
} from "../.././vuex/mutation_types";
export default {
    name: 'App',
    data() {
        return {
            active_page: '', // 当前页面路径
            isLogin: false, // 登录状态,
        }
    },
    mounted() {},
    created() {
        this.active_page = this.$route.path;
    },
    watch: {
        '$route': function (to, from) {
            // console.log(to.path);
            if (window.localStorage.user_name != undefined && window.localStorage.user_name != null && window.localStorage.user_name != '') {
                this.name = window.localStorage.user_name;
                this.isLogin = true
            } else {
                this.name = '';
                this.isLogin = false;
            }
            this.active_page = to.path;
        }
    },
    methods: {
    },
}
</script>
